var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithoutSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40035 4.13208C0.289494 8.32112 0.633965 14.2678 4.43376 18.0676C4.70713 18.3409 5.15034 18.3409 5.42371 18.0676C5.69708 17.7942 5.69708 17.351 5.42371 17.0776C2.17189 13.8258 1.83161 8.765 4.40285 5.13458L3.40035 4.13208ZM6.27926 7.01099C4.70228 9.59085 5.03 13.0067 7.26241 15.2391C7.53578 15.5125 7.97899 15.5125 8.25236 15.2391C8.52573 14.9657 8.52573 14.5225 8.25236 14.2491C6.57092 12.5677 6.25544 10.0376 7.30593 8.03765L6.27926 7.01099ZM9.33487 10.0666C9.31194 10.2082 9.30003 10.3535 9.30003 10.5015C9.30003 11.7506 10.1482 12.8016 11.3 13.1099V21.5015C11.3 21.8881 11.6134 22.2015 12 22.2015C12.3866 22.2015 12.7 21.8881 12.7 21.5015V13.4318L9.33487 10.0666ZM17.5431 14.2673L16.5304 13.2545C17.7722 11.2147 17.5113 8.51742 15.7477 6.75381C15.4744 6.48045 15.4744 6.03723 15.7477 5.76386C16.0211 5.4905 16.4643 5.4905 16.7377 5.76386C19.0505 8.07664 19.3189 11.6596 17.5431 14.2673ZM20.4032 17.1274L19.4054 16.1295C22.1832 12.4841 21.9069 7.25596 18.5763 3.92544C18.303 3.65208 18.303 3.20886 18.5763 2.93549C18.8497 2.66213 19.2929 2.66213 19.5663 2.93549C23.4443 6.8135 23.7233 12.9276 20.4032 17.1274ZM14.579 11.3032L13.1244 9.84851C13.0109 9.65349 12.8481 9.49068 12.653 9.37717L11.1984 7.92251C11.4516 7.84387 11.7209 7.80151 12 7.80151C13.4912 7.80151 14.7 9.01034 14.7 10.5015C14.7 10.7807 14.6577 11.0499 14.579 11.3032Z",
    fill: "#CD5A5A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.89233,
    y: 1.79297,
    width: 25.9094,
    height: 1.62569,
    rx: 0.812845,
    transform: "rotate(45 2.89233 1.79297)",
    fill: "#CD5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithoutSignal);
export default __webpack_public_path__ + "static/media/without-signal.ee2c35ab2ff8ed8b17a3f5d07d28c883.svg";
export { ForwardRef as ReactComponent };